import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-sm text-muted-foreground font-mono">Loading TPMS…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
